/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { useContext } from 'react';
import { Card, Icon } from '@scuf/common';
import { useTranslation } from '@scuf/localization';
import descriptors from '../../../../locales/en-US/descriptors';
import IEnergyManagementProps from '../../IEnergyManagementProps';
import { ApiContext } from '../../../../context/ApiContext';
import './EnergyOptimizationViewDetailsTheme.scss';
import { DataContextProvider } from '@forge/data-connector';
import EnergyOptimizationSiteWidget from '../EnergyOptimizationSiteWidget/EnergyOptimizationSiteWidget';
import EOByUtilitySiteWidget from '../EnergyOptimizationSiteWidget/EODetailsByUtility/EOByUtilitySiteWidget';

const EnergyOptimizationViewDetailsComponentContent = (
  props: IEnergyManagementProps
) => {
  const { bearerToken, requestContext } = props;
  const d = descriptors.energyManagement;
  const [t] = useTranslation();

  const apiContext = useContext(ApiContext);
  const { onBacktoDashboardClick, toggleUtilityLevelIBO } = apiContext;

  const onBackarrowClick = () => {
    if (onBacktoDashboardClick) {
      onBacktoDashboardClick();
    }
  };

  return (
    <div className="emaas-energy-optimization-detail-container">
      <Card>
        <Card.Header className="emaas-energy-optimization-viewDetails-kpi-header-container">
          <div className="emaas-energy-optimization-viewDetails-kpi-card-title">
            <span className="energy-optimization-backButton">
              <Icon
                root="common"
                name="arrow-left"
                size="medium"
                onClick={() => onBackarrowClick()}
              />
            </span>
            {t(d.ENERGYOPTIMIZATIONNEW)}
          </div>
        </Card.Header>
        <Card.Content className="emaas-energy-optimization-viewDetails-kpi-content-container">
          <DataContextProvider config={props.connectorConfig}>
            <div className="energy-optimization-viewDetails-graph">
              {!toggleUtilityLevelIBO ? (
                <EnergyOptimizationSiteWidget
                  bearerToken={bearerToken}
                  requestContext={requestContext}
                  mainGraph={false}
                  connectorConfig={props.connectorConfig}
                  isAllUtility={true}
                />
              ) : (
                <EOByUtilitySiteWidget
                  bearerToken={bearerToken}
                  requestContext={requestContext}
                  mainGraph={false}
                  connectorConfig={props.connectorConfig}
                />
              )}
            </div>
          </DataContextProvider>
        </Card.Content>
      </Card>
    </div>
  );
};

export default EnergyOptimizationViewDetailsComponentContent;
